/*
 * Copyright (c) 2019 Signum+ Software & Facility GmbH
 * Author: jahn@signum-plus.at
 */

import { CoreErrorKey } from '../key/core-error.key';

export interface ApplicationErrorData {
  key: string;
  arguments?: { [key: string]: any };
  message?: string;
  stack?: string;
}

// DO NOT INHERIT FROM ERROR -> NOT WORKING IN IE 11
// export class ApplicationError extends Error implements ApplicationErrorData {
export class ApplicationError implements ApplicationErrorData {
  public readonly key: string;
  public readonly arguments: { [key: string]: any };
  public readonly message: string;
  public readonly stack: string;

  // tslint:disable-next-line: max-line-length
  // https://github.com/Microsoft/TypeScript-wiki/blob/master/Breaking-Changes.md#extending-built-ins-like-error-array-and-map-may-no-longer-work
  // https://github.com/microsoft/TypeScript/issues/12123
  constructor(data: ApplicationErrorData) {
    // super(data.message);
    // Object.setPrototypeOf(this, ApplicationError.prototype);
    this.key = data.key || CoreErrorKey.UNDEFINED_ERROR;
    this.arguments = data.arguments;
    this.message = data.message || '';
    this.stack = data.stack || new Error().stack;
  }

  toJSON(): ApplicationErrorData {
    let args: any;
    if (this.arguments && typeof this.arguments === 'object') {
      args = {};
      Object.keys(this.arguments).forEach((argumentKey) => {
        const argument = this.arguments[argumentKey];
        if (Array.isArray(argument)) {
          args[argumentKey] = argument.map(
            (item) => item && typeof item['toJSON'] === 'function'
              ? item.toJSON()
              : item
          );
        } else {
          args[argumentKey] = argument && typeof argument['toJSON'] === 'function'
            ? argument.toJSON()
            : argument;
        }
      });
    } else {
      args = this.arguments;
    }
    return { key: this.key, arguments: args, message: this.message };
  }

  toString() {
    return JSON.stringify({ key: this.key, arguments: this.arguments, stack: this.stack }, null, 2);
  }

  static from(error: any): ApplicationError {
    if (error instanceof ApplicationError) {
      return error;
    }
    if (error instanceof Error) {
      return new ApplicationError({
        key: CoreErrorKey.UNDEFINED_ERROR,
        arguments: { error },
        message: `Undefined error: ${error.message}`,
        stack: error.stack
      });
    }
    return new ApplicationError({
      key: CoreErrorKey.UNDEFINED_ERROR,
      arguments: { error },
      message: `Undefined error: ${JSON.stringify(error)}`
    });
  }

}
